import { render, staticRenderFns } from "./PDF_Comment.vue?vue&type=template&id=25f17f27&scoped=true"
import script from "./PDF_Comment.vue?vue&type=script&lang=js"
export * from "./PDF_Comment.vue?vue&type=script&lang=js"
import style0 from "./PDF_Comment.vue?vue&type=style&index=0&id=25f17f27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f17f27",
  null
  
)

export default component.exports